import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import type {IAppDispatch, IRootState} from "../../store/store";
import {getUserProfileApi, selectUserProfile} from "../../user/api/get_user_profile";
import {IUserProfile} from "../../user/types/IUserProfile";
import {nextStep} from "../state/registration_flow_slice";
import {RegistrationFlowStep} from "../types/RegistrationFlowStep";
import {getRegistrationFlowUserState} from "../utils/get_registration_flow_user_state";

export const advanceRegistrationFlow = () => async (dispatch: IAppDispatch, getState: () => IRootState) => {
    const {runId, currentStep} = getState().registrationFlow;
    const isSameStepOfRun = () => {
        const flowState = getState().registrationFlow;

        return flowState.isActive && flowState.runId === runId && flowState.currentStep === currentStep;
    };
    let userProfile: IUserProfile | null;

    try {
        userProfile = await dispatch(getUserProfileApi.endpoints.getUserProfile.initiate(undefined, {forceRefetch: true, subscribe: false})).unwrap();
    } catch {
        if (currentStep === RegistrationFlowStep.PHONE_COMPLETION) {
            if (isSameStepOfRun()) {
                dispatch(addNotification({notification: defaultAPIErrorNotification}));
            }

            return;
        }

        userProfile = selectUserProfile(getState()).data ?? null;
    }

    if (!isSameStepOfRun()) {
        return;
    }

    const {hasCompleteProfile, hasPhoneVerified, hasPhone, hasName} = getRegistrationFlowUserState(userProfile);

    dispatch(nextStep({hasCompleteProfile, hasPhoneVerified, hasPhone, hasName}));
};
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import type {IAppDispatch, IRootState} from "../../store/store";
import {getUserProfileApi, selectUserProfile} from "../../user/api/get_user_profile";
import {IUserProfile} from "../../user/types/IUserProfile";
import {nextStep} from "../state/registration_flow_slice";
import {RegistrationFlowStep} from "../types/RegistrationFlowStep";
import {getRegistrationFlowUserState} from "../utils/get_registration_flow_user_state";

export const advanceRegistrationFlow = () => async (dispatch: IAppDispatch, getState: () => IRootState) => {
    const {runId, currentStep} = getState().registrationFlow;
    const isSameStepOfRun = () => {
        const flowState = getState().registrationFlow;

        return flowState.isActive && flowState.runId === runId && flowState.currentStep === currentStep;
    };
    let userProfile: IUserProfile | null;

    try {
        userProfile = await dispatch(getUserProfileApi.endpoints.getUserProfile.initiate(undefined, {forceRefetch: true, subscribe: false})).unwrap();
    } catch {
        if (currentStep === RegistrationFlowStep.PHONE_COMPLETION) {
            if (isSameStepOfRun()) {
                dispatch(addNotification({notification: defaultAPIErrorNotification}));
            }

            return;
        }

        userProfile = selectUserProfile(getState()).data ?? null;
    }

    if (!isSameStepOfRun()) {
        return;
    }

    const {hasCompleteProfile, hasPhoneVerified, hasPhone, hasName} = getRegistrationFlowUserState(userProfile);

    dispatch(nextStep({hasCompleteProfile, hasPhoneVerified, hasPhone, hasName}));
};
